import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
} from '@mui/material';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { ColorModeContext } from '../contexts/ColorModeContext';
import { palette, typography } from '../theme/colors';
import { useAnimationStyles } from '../hooks/useAnimations';
import { FeatureComparison } from '../components/subscription/FeatureComparison';
import { SubscriptionTier } from '../types/subscription';

export const UpgradePage = () => {
  const { mode } = useContext(ColorModeContext);
  const animations = useAnimationStyles();
  const navigate = useNavigate();

  // TODO: Fetch actual subscription tier from organization data
  const currentTier: SubscriptionTier = 'free';

  const colors = mode === 'dark' ? {
    bg: palette.background,
    surface: palette.surface,
    surfaceElevated: palette.surfaceElevated,
    border: palette.border,
    textPrimary: palette.textPrimary,
    textSecondary: palette.textSecondary,
    textMuted: palette.textMuted,
  } : {
    bg: palette.light.background,
    surface: palette.light.surface,
    surfaceElevated: palette.light.surfaceElevated,
    border: palette.light.border,
    textPrimary: palette.light.textPrimary,
    textSecondary: palette.light.textSecondary,
    textMuted: palette.light.textMuted,
  };

  const handleUpgrade = (tier: SubscriptionTier) => {
    // Navigate to checkout or contact sales page
    if (tier === 'enterprise') {
      navigate('/contact-sales');
    } else {
      navigate(`/checkout/${tier}`);
    }
  };

  return (
    <Box sx={{ ...animations.fadeIn }}>
      {/* Header */}
      <Box sx={{ mb: 4, ...animations.slideDown }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <RocketLaunchIcon sx={{ color: palette.primary, fontSize: 24 }} />
          <Typography
            variant="overline"
            sx={{
              color: palette.primary,
              fontFamily: typography.fontFamily.mono,
              fontSize: typography.fontSize.xs,
              letterSpacing: typography.letterSpacing.widest,
              fontWeight: typography.fontWeight.bold,
            }}
          >
            SUBSCRIPTION TIERS
          </Typography>
        </Box>
        <Typography
          variant="h3"
          sx={{
            fontFamily: typography.fontFamily.display,
            fontWeight: typography.fontWeight.extrabold,
            color: colors.textPrimary,
            letterSpacing: '-0.02em',
            lineHeight: 1.1,
          }}
        >
          UPGRADE YOUR PLAN
        </Typography>
        <Typography variant="body2" sx={{ color: colors.textSecondary, mt: 1 }}>
          Choose the plan that best fits your business needs
        </Typography>
      </Box>

      {/* Feature Comparison Table */}
      <Box sx={{ ...animations.slideUp(0.2) }}>
        <FeatureComparison
          currentTier={currentTier}
          onUpgrade={handleUpgrade}
          showUpgradeButtons={true}
        />
      </Box>
    </Box>
  );
};

export default UpgradePage;
